function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "utils", () => $d7167569386d0d4c$exports);
var $d7167569386d0d4c$exports = {};
var $3bca631f7e12b649$exports = {};

$parcel$export($3bca631f7e12b649$exports, "delay", () => $3bca631f7e12b649$export$1391212d75b2ee65);
function $3bca631f7e12b649$export$1391212d75b2ee65(timeInMillis) {
    return new Promise((resolve)=>setTimeout(()=>resolve(), timeInMillis));
}


var $8f8d85013a66f887$exports = {};

$parcel$export($8f8d85013a66f887$exports, "getDebugGroup", () => $8f8d85013a66f887$export$c70183eb5acc76d7);
function $8f8d85013a66f887$export$c70183eb5acc76d7() {
    const searchParams = new URLSearchParams(window.location.search.substring(1));
    if (Boolean(searchParams.get("adengine_debug"))) return searchParams.get("adengine_debug");
    return searchParams.get("identity_debug");
}


var $d9d01dee3649e94d$exports = {};

$parcel$export($d9d01dee3649e94d$exports, "localStorageHelper", () => $d9d01dee3649e94d$export$2a8d33e352660a9b);
class $d9d01dee3649e94d$export$2a8d33e352660a9b {
    constructor(key, ttlInMilliseconds = 60000){
        this.key = key;
        this.ttlInMilliseconds = ttlInMilliseconds;
    }
    expired(ttl) {
        return ttl ? ttl < Date.now() : true;
    }
    getObjectToStore(data) {
        return {
            data: data,
            ttl: Date.now() + this.ttlInMilliseconds
        };
    }
    parseStoredValue(storedValue) {
        const json = JSON.parse(storedValue);
        return this.expired(json?.ttl) ? null : json.data;
    }
    get() {
        const storedValue = localStorage.getItem(this.key);
        return !storedValue ? null : this.parseStoredValue(storedValue);
    }
    set(data) {
        const objectToStore = this.getObjectToStore(data);
        localStorage.setItem(this.key, JSON.stringify(objectToStore));
    }
}


var $30ba9362ac1ffe4b$exports = {};

$parcel$export($30ba9362ac1ffe4b$exports, "lock", () => $30ba9362ac1ffe4b$export$6a9f04c98a658ecb);
$parcel$export($30ba9362ac1ffe4b$exports, "release", () => $30ba9362ac1ffe4b$export$23d3fad09dc44362);

const $30ba9362ac1ffe4b$var$storage = new (0, $d9d01dee3649e94d$export$2a8d33e352660a9b)("instant-config-lock", 1000);
function $30ba9362ac1ffe4b$export$6a9f04c98a658ecb() {
    if ($30ba9362ac1ffe4b$var$storage.get() === "lock") return true;
    $30ba9362ac1ffe4b$var$storage.set("lock");
    return false;
}
function $30ba9362ac1ffe4b$export$23d3fad09dc44362() {
    $30ba9362ac1ffe4b$var$storage.set(null);
}


var $e0f8e7cf88064837$exports = {};

$parcel$export($e0f8e7cf88064837$exports, "getTimeDelta", () => $e0f8e7cf88064837$export$85f2155d703a252d);
$parcel$export($e0f8e7cf88064837$exports, "logger", () => $e0f8e7cf88064837$export$af88d00dbe7f521);
$parcel$export($e0f8e7cf88064837$exports, "warner", () => $e0f8e7cf88064837$export$73a23a961d4d2188);

const $e0f8e7cf88064837$var$debugGroup = (0, $8f8d85013a66f887$export$c70183eb5acc76d7)() || "";
const $e0f8e7cf88064837$var$groups = $e0f8e7cf88064837$var$debugGroup.split(",");
const $e0f8e7cf88064837$var$BACKUP_ORIGIN_TIME = Date.now();
function $e0f8e7cf88064837$export$85f2155d703a252d() {
    const currentTimeStamp = Date.now();
    const originTime = window.performance?.timeOrigin ?? $e0f8e7cf88064837$var$BACKUP_ORIGIN_TIME;
    const delta = currentTimeStamp - originTime;
    const secondsResult = delta / 1000;
    return secondsResult.toFixed(4);
}
function $e0f8e7cf88064837$export$af88d00dbe7f521(logGroup, ...logValues) {
    if ($e0f8e7cf88064837$var$debugGroup === "") return;
    if ($e0f8e7cf88064837$var$debugGroup === "1" || $e0f8e7cf88064837$var$groups.indexOf(logGroup) !== -1) window.console.info(`${$e0f8e7cf88064837$export$85f2155d703a252d()}s\t\t ${logGroup}`, logValues);
}
function $e0f8e7cf88064837$export$73a23a961d4d2188(warnGroup, ...warnValues) {
    if ($e0f8e7cf88064837$var$debugGroup === "") return;
    if ($e0f8e7cf88064837$var$debugGroup === "1" || $e0f8e7cf88064837$var$groups.indexOf(warnGroup) !== -1) window.console.warn(warnGroup, warnValues);
}


$parcel$exportWildcard($d7167569386d0d4c$exports, $3bca631f7e12b649$exports);
$parcel$exportWildcard($d7167569386d0d4c$exports, $8f8d85013a66f887$exports);
$parcel$exportWildcard($d7167569386d0d4c$exports, $d9d01dee3649e94d$exports);
$parcel$exportWildcard($d7167569386d0d4c$exports, $30ba9362ac1ffe4b$exports);
$parcel$exportWildcard($d7167569386d0d4c$exports, $e0f8e7cf88064837$exports);


var $583683d1b436d65c$exports = {};
var $d4581a365416e9ee$exports = {};

$parcel$export($d4581a365416e9ee$exports, "EmptyInstantConfigCacheStorage", () => $d4581a365416e9ee$export$c81e13f6e9617a56);
class $d4581a365416e9ee$export$c81e13f6e9617a56 {
    get(id) {
        return undefined;
    }
    set(data) {}
}


var $15d63f1bfc4bb821$exports = {};

$parcel$export($15d63f1bfc4bb821$exports, "InstantConfigInterpreter", () => $15d63f1bfc4bb821$export$482d435527222f10);


var $89ffc9b2062f304b$exports = {};
var $405744dd7ce6d50f$exports = {};

$parcel$export($405744dd7ce6d50f$exports, "BrowserMatcher", () => $405744dd7ce6d50f$export$4505b7bf40f87994);
var $ddc7f0da9f8c7cab$exports = {};

$parcel$export($ddc7f0da9f8c7cab$exports, "extractNegation", () => $ddc7f0da9f8c7cab$export$a3f4cf710f4ee0af);
var $b9c8418edb6cb5ed$exports = {};
var $8dbd42f8585f4a0f$exports = {};


var $f37386de1dafa5cb$exports = {};


var $136f43ccf5c8a695$exports = {};


var $1573f882a631b63d$exports = {};


var $3acdfa9f3a7dc4e4$exports = {};


var $3694c9182cdb2fa5$exports = {};


var $1af23f87dbb2a880$exports = {};


var $5ee3e5908b33855d$exports = {};


var $8514c556b5f7df10$exports = {};


var $4c1928f7ffe746a1$exports = {};

$parcel$export($4c1928f7ffe746a1$exports, "negativePrefix", () => $4c1928f7ffe746a1$export$6a1a21b83e21c671);
$parcel$export($4c1928f7ffe746a1$exports, "cacheSuffix", () => $4c1928f7ffe746a1$export$4940459403f61e72);
$parcel$export($4c1928f7ffe746a1$exports, "samplingSeparator", () => $4c1928f7ffe746a1$export$8c99e8be8e35246);
$parcel$export($4c1928f7ffe746a1$exports, "worldWide", () => $4c1928f7ffe746a1$export$aea6dbf29fd09cb3);
$parcel$export($4c1928f7ffe746a1$exports, "precision", () => $4c1928f7ffe746a1$export$b70eeb0e623ceb0d);
const $4c1928f7ffe746a1$export$6a1a21b83e21c671 = "non-";
const $4c1928f7ffe746a1$export$4940459403f61e72 = "-cached";
const $4c1928f7ffe746a1$export$8c99e8be8e35246 = "/";
const $4c1928f7ffe746a1$export$aea6dbf29fd09cb3 = "XX";
const $4c1928f7ffe746a1$export$b70eeb0e623ceb0d = 10 ** 6;


$parcel$exportWildcard($b9c8418edb6cb5ed$exports, $8dbd42f8585f4a0f$exports);
$parcel$exportWildcard($b9c8418edb6cb5ed$exports, $f37386de1dafa5cb$exports);
$parcel$exportWildcard($b9c8418edb6cb5ed$exports, $136f43ccf5c8a695$exports);
$parcel$exportWildcard($b9c8418edb6cb5ed$exports, $1573f882a631b63d$exports);
$parcel$exportWildcard($b9c8418edb6cb5ed$exports, $3acdfa9f3a7dc4e4$exports);
$parcel$exportWildcard($b9c8418edb6cb5ed$exports, $3694c9182cdb2fa5$exports);
$parcel$exportWildcard($b9c8418edb6cb5ed$exports, $1af23f87dbb2a880$exports);
$parcel$exportWildcard($b9c8418edb6cb5ed$exports, $5ee3e5908b33855d$exports);
$parcel$exportWildcard($b9c8418edb6cb5ed$exports, $8514c556b5f7df10$exports);
$parcel$exportWildcard($b9c8418edb6cb5ed$exports, $4c1928f7ffe746a1$exports);


function $ddc7f0da9f8c7cab$export$a3f4cf710f4ee0af(input) {
    return input.startsWith((0, $4c1928f7ffe746a1$export$6a1a21b83e21c671)) ? {
        value: input.replace((0, $4c1928f7ffe746a1$export$6a1a21b83e21c671), ""),
        negated: true
    } : {
        value: input,
        negated: false
    };
}


class $405744dd7ce6d50f$export$4505b7bf40f87994 {
    constructor(currentBrowser){
        this.currentBrowser = currentBrowser?.toLowerCase();
    }
    isValid(browsers = []) {
        const browserObjects = browsers.map((browser)=>browser.toLowerCase()).map((browser)=>(0, $ddc7f0da9f8c7cab$export$a3f4cf710f4ee0af)(browser));
        if (browsers.length === 0) return true;
        if (!this.currentBrowser) return true; // FIXME: na pewno? unit test
        if (this.isCurrentNegated(this.currentBrowser, browserObjects)) return false;
        return browserObjects.some((object)=>this.currentBrowser.includes(object.value) !== object.negated);
    }
    isCurrentNegated(currentBrowser, browserObjects) {
        return browserObjects.some((object)=>currentBrowser.includes(object.value) && object.negated);
    }
}


var $e81ea42c614be70e$exports = {};

$parcel$export($e81ea42c614be70e$exports, "DeviceMatcher", () => $e81ea42c614be70e$export$b2a88ef241f2bd3f);

class $e81ea42c614be70e$export$b2a88ef241f2bd3f {
    constructor(currentDevice){
        this.currentDevice = currentDevice;
    }
    isValid(devices = []) {
        const deviceObjects = devices.map((browser)=>browser.toLowerCase()).map((browser)=>(0, $ddc7f0da9f8c7cab$export$a3f4cf710f4ee0af)(browser));
        if (deviceObjects.length === 0) return true;
        if (!this.currentDevice) return true; // FIXME: na pewno? unit test
        if (this.isCurrentNegated(this.currentDevice, deviceObjects)) return false;
        return deviceObjects.some((object)=>object.value === this.currentDevice !== object.negated);
    }
    isCurrentNegated(currentDevice, deviceObjects) {
        return deviceObjects.some((object)=>currentDevice.includes(object.value) && object.negated);
    }
}


var $56c45358b989a2ec$exports = {};

$parcel$export($56c45358b989a2ec$exports, "DomainMatcher", () => $56c45358b989a2ec$export$48fd90bf831be0f8);
class $56c45358b989a2ec$export$48fd90bf831be0f8 {
    isValid(domains = []) {
        if (domains.length === 0) return true;
        return domains.some((domain)=>window.location.hostname.includes(domain));
    }
}



var $8965000d96eca076$exports = {};

$parcel$export($8965000d96eca076$exports, "RegionMatcher", () => $8965000d96eca076$export$9dd39bf33dcd6ef6);

class $8965000d96eca076$export$9dd39bf33dcd6ef6 {
    constructor(geo){
        this.geo = geo;
    }
    isValid(regions = [], validateRegionPredicate) {
        const validRegions = this.filterOutInvalidRegions(regions);
        return validateRegionPredicate ? validateRegionPredicate(validRegions) : this.isProperGeo(validRegions);
    }
    getCountryCode() {
        return this.geo?.country;
    }
    getRegionCode() {
        return this.geo?.region;
    }
    getContinentCode() {
        return this.geo?.continent;
    }
    isProperGeo(countryList = []) {
        return !!(countryList && countryList.indexOf && !this.isGeoExcluded(countryList) && (this.isProperContinent(countryList) || this.isProperCountry(countryList) || this.isProperRegion(countryList)));
    }
    filterOutInvalidRegions(regions) {
        return regions.filter((region)=>!region.includes((0, $4c1928f7ffe746a1$export$8c99e8be8e35246))).filter((region)=>!region.includes((0, $4c1928f7ffe746a1$export$4940459403f61e72)));
    }
    isProperCountry(countryList) {
        return !!(countryList && countryList.indexOf && (countryList.indexOf(this.getCountryCode()) > -1 || this.isSampledForGeo(countryList, this.getCountryCode())));
    }
    isProperRegion(countryList) {
        const code = `${this.getCountryCode()}-${this.getRegionCode()}`;
        return !!(countryList && countryList.indexOf && (countryList.indexOf(code) > -1 || this.isSampledForGeo(countryList, code)));
    }
    containsContinent(countryList) {
        const geo = `${(0, $4c1928f7ffe746a1$export$aea6dbf29fd09cb3)}-${this.getContinentCode()}`;
        return countryList.indexOf(geo) > -1 || this.isSampledForGeo(countryList, geo);
    }
    containsWorldWide(countryList) {
        return countryList.indexOf((0, $4c1928f7ffe746a1$export$aea6dbf29fd09cb3)) > -1 || this.isSampledForGeo(countryList, (0, $4c1928f7ffe746a1$export$aea6dbf29fd09cb3));
    }
    isProperContinent(countryList) {
        return !!(countryList && countryList.indexOf && (this.containsWorldWide(countryList) || this.containsContinent(countryList)));
    }
    isGeoExcluded(countryList) {
        return !!(countryList.indexOf(`${(0, $4c1928f7ffe746a1$export$6a1a21b83e21c671)}${this.getCountryCode()}`) > -1 || countryList.indexOf(`${(0, $4c1928f7ffe746a1$export$6a1a21b83e21c671)}${this.getCountryCode()}-${this.getRegionCode()}`) > -1 || countryList.indexOf(`${(0, $4c1928f7ffe746a1$export$6a1a21b83e21c671)}${(0, $4c1928f7ffe746a1$export$aea6dbf29fd09cb3)}-${this.getContinentCode()}`) > -1);
    }
    hasSampling(geo) {
        return (value)=>value.indexOf((0, $4c1928f7ffe746a1$export$6a1a21b83e21c671)) !== 0 && value.indexOf(geo + (0, $4c1928f7ffe746a1$export$8c99e8be8e35246)) > -1;
    }
    getSamplingLimits(value) {
        let [, samplingValue] = value.split((0, $4c1928f7ffe746a1$export$8c99e8be8e35246));
        samplingValue = samplingValue.replace((0, $4c1928f7ffe746a1$export$4940459403f61e72), "");
        return Math.round(parseFloat(samplingValue) * (0, $4c1928f7ffe746a1$export$b70eeb0e623ceb0d)) || 0;
    }
    isSampledForGeo(countryList, geo) {
        const countryListWithSampling = countryList.filter(this.hasSampling(geo));
        if (countryListWithSampling.length === 0) return false;
        const randomValue = Math.round(Math.random() * ((0, $4c1928f7ffe746a1$export$b70eeb0e623ceb0d) * 100)) || 0;
        return countryListWithSampling.map((value)=>this.getSamplingLimits(value)).some((value)=>randomValue < value);
    }
}


var $aa30ebecbe06fe3a$exports = {};

$parcel$export($aa30ebecbe06fe3a$exports, "SamplingCacheManager", () => $aa30ebecbe06fe3a$export$7e75aba54255ff4a);
class $aa30ebecbe06fe3a$export$7e75aba54255ff4a {
    constructor(cacheStorage){
        this.cacheStorage = cacheStorage;
        this.precision = 10 ** 6;
    }
    apply(id, samplingCache, predicate) {
        const cached = this.cacheStorage.get(id);
        if (typeof cached !== "undefined") return cached.result;
        const value = predicate();
        if (typeof samplingCache.sampling !== "number" || value === false) return value;
        const samplingResult = this.getSamplingResult(samplingCache.sampling);
        const cacheData = {
            name: id,
            result: samplingResult,
            withCookie: Boolean(samplingCache.samplingCache),
            group: samplingResult ? "B" : "A",
            limit: +(samplingResult ? samplingCache.sampling : 100 - samplingCache.sampling).toFixed(6)
        };
        this.cacheStorage.set(cacheData);
        return samplingResult;
    }
    getSamplingResult(sampling) {
        const randomValue = Math.round(Math.random() * 100 * this.precision);
        const samplingValue = Math.round(sampling * this.precision);
        return samplingValue > randomValue;
    }
}


$parcel$exportWildcard($89ffc9b2062f304b$exports, $405744dd7ce6d50f$exports);
$parcel$exportWildcard($89ffc9b2062f304b$exports, $e81ea42c614be70e$exports);
$parcel$exportWildcard($89ffc9b2062f304b$exports, $56c45358b989a2ec$exports);
$parcel$exportWildcard($89ffc9b2062f304b$exports, $ddc7f0da9f8c7cab$exports);
$parcel$exportWildcard($89ffc9b2062f304b$exports, $8965000d96eca076$exports);
$parcel$exportWildcard($89ffc9b2062f304b$exports, $aa30ebecbe06fe3a$exports);


class $15d63f1bfc4bb821$export$482d435527222f10 {
    constructor(browserMatcher = new (0, $405744dd7ce6d50f$export$4505b7bf40f87994)(), deviceMatcher = new (0, $e81ea42c614be70e$export$b2a88ef241f2bd3f)(), domainMatcher = new (0, $56c45358b989a2ec$export$48fd90bf831be0f8)(), regionMatcher = new (0, $8965000d96eca076$export$9dd39bf33dcd6ef6)(), instantConfigCacheService = new (0, $d4581a365416e9ee$export$c81e13f6e9617a56)()){
        this.browserMatcher = browserMatcher;
        this.deviceMatcher = deviceMatcher;
        this.domainMatcher = domainMatcher;
        this.regionMatcher = regionMatcher;
        this.instantConfigCacheService = instantConfigCacheService;
        this.logGroup = "instant-config-interpreter";
        this.configResponse = {};
        this.samplingCache = new (0, $aa30ebecbe06fe3a$export$7e75aba54255ff4a)(instantConfigCacheService);
    }
    init(instantConfig, instantGlobals = {}, regionValidationPredicate) {
        this.configResponse = {
            ...instantGlobals,
            ...instantConfig
        };
        this.regionValidationPredicate = regionValidationPredicate;
        return this;
    }
    getValues() {
        (0, $d7167569386d0d4c$exports).logger(this.logGroup, "get values called with", this.configResponse);
        return Object.keys(this.configResponse).map((key)=>({
                key: key,
                value: this.configResponse[key]
            })).map(({ key: key , value: value  })=>{
            if (!Array.isArray(value)) return {
                key: key,
                value: value
            };
            return {
                key: key,
                value: this.getValue(key, value)
            };
        }).reduce((prev, curr)=>({
                ...prev,
                [curr.key]: curr.value
            }), {});
    }
    getValue(key, groups) {
        const correct = groups.find((group, index)=>this.samplingCache.apply(`${key}-${index}`, group, this.getPredicate(group)));
        if (typeof correct !== "undefined") return correct.value;
        return undefined;
    }
    getPredicate(group) {
        return ()=>this.browserMatcher.isValid(group.browsers) && this.deviceMatcher.isValid(group.devices) && this.domainMatcher.isValid(group.domains) && this.regionMatcher.isValid(group.regions, this.regionValidationPredicate);
    }
}


var $85c45f0adbe836ae$exports = {};

$parcel$export($85c45f0adbe836ae$exports, "InstantConfigLoader", () => $85c45f0adbe836ae$export$f46cdbfb0a457ef7);


async function $d4bf72cd649cb2a4$export$a986389b0f83d258(url, timeout = 2000) {
    const controller = new AbortController();
    const id = setTimeout(()=>controller.abort(), timeout);
    const response = await fetch(url, {
        signal: controller.signal
    });
    clearTimeout(id);
    return response;
}


const $85c45f0adbe836ae$var$logGroup = "instant-config-loader";
const $85c45f0adbe836ae$var$instantConfigKey = "instantConfig";
const $85c45f0adbe836ae$var$instantConfigProps = {
    b: "browsers",
    d: "devices",
    s: "sampling",
    c: "samplingCache",
    r: "regions",
    v: "value"
};
class $85c45f0adbe836ae$export$f46cdbfb0a457ef7 {
    constructor(params, container = window){
        this.params = params;
        this.configPromise = null;
        this.storage = new (0, $d7167569386d0d4c$exports).localStorageHelper(`instant-config-${params.appName}`, 60000);
        this.instantConfig = this.fromContainer(container);
    }
    async getConfig() {
        if (this.instantConfig) return this.instantConfig;
        if (!this.configPromise) this.configPromise = this.fetchInstantConfig().then((config)=>{
            return config ?? this.fetchFallbackConfig();
        });
        return this.configPromise.then((config)=>{
            return config;
        });
    }
    async fetchInstantConfig(fallback = false) {
        const locked = (0, $d7167569386d0d4c$exports).lock();
        if (locked && !fallback) {
            await (0, $3bca631f7e12b649$export$1391212d75b2ee65)(500);
            // try again, if lock is still present then try LocalStorage or fetch from ICBM
            return this.fetchInstantConfig(true);
        }
        const baseUrl = this.params.instantConfigEndpoint ?? "https://services.fandom.com";
        const variant = this.params.instantConfigVariant ?? "icbm";
        const appName = this.params.appName;
        const url = `${baseUrl}/${variant}/api/config?app=${appName}`;
        try {
            const cachedConfigString = this.storage.get();
            if (cachedConfigString) {
                (0, $d7167569386d0d4c$exports).logger($85c45f0adbe836ae$var$logGroup, "instant config pulled from local storage", cachedConfigString);
                return JSON.parse(cachedConfigString);
            }
            const response = await (0, $d4bf72cd649cb2a4$export$a986389b0f83d258)(url, this.params.requestTimeout);
            if (!response.ok) return undefined;
            const instantConfig = await response.json();
            this.storage.set(JSON.stringify(instantConfig));
            (0, $d7167569386d0d4c$exports).release();
            (0, $d7167569386d0d4c$exports).logger($85c45f0adbe836ae$var$logGroup, "instant config fetched", instantConfig);
            return instantConfig;
        } catch (err) {
            (0, $d7167569386d0d4c$exports).warner($85c45f0adbe836ae$var$logGroup, "could not fetch instant config", err);
            (0, $d7167569386d0d4c$exports).release();
            return undefined;
        }
    }
    async fetchFallbackConfig() {
        (0, $d7167569386d0d4c$exports).logger($85c45f0adbe836ae$var$logGroup, "Fetching fallback config");
        const fallbackEndpoint = this.params.instantConfigFallbackEndpoint;
        if (typeof fallbackEndpoint === "undefined") return {};
        try {
            (0, $d7167569386d0d4c$exports).logger($85c45f0adbe836ae$var$logGroup, fallbackEndpoint);
            const response = await (0, $d4bf72cd649cb2a4$export$a986389b0f83d258)(fallbackEndpoint, this.params.requestTimeout);
            if (!response.ok) return {};
            const fallbackConfig = await response.json();
            (0, $d7167569386d0d4c$exports).logger($85c45f0adbe836ae$var$logGroup, "fallback config fetched", fallbackConfig);
            return fallbackConfig;
        } catch (err) {
            (0, $d7167569386d0d4c$exports).warner($85c45f0adbe836ae$var$logGroup, "could not fetch fallback config", err);
            return {};
        }
    }
    fromContainer(container) {
        let appConfig = container[$85c45f0adbe836ae$var$instantConfigKey];
        if (typeof appConfig === "object" && !appConfig._ready) {
            Object.keys(appConfig).forEach((key)=>{
                const value = appConfig[key];
                if (Array.isArray(value)) appConfig[key] = value.map((e)=>Object.fromEntries(Object.entries(e).map(([k, v])=>[
                            $85c45f0adbe836ae$var$instantConfigProps[k] ? $85c45f0adbe836ae$var$instantConfigProps[k] : k,
                            v
                        ])));
            });
            appConfig._ready = true;
            container[$85c45f0adbe836ae$var$instantConfigKey] = appConfig;
        }
        return appConfig;
    }
}


var $8031b44000f2c28f$exports = {};

$parcel$export($8031b44000f2c28f$exports, "InstantConfigOverrider", () => $8031b44000f2c28f$export$14a2f5ed2c1a484d);
const $8031b44000f2c28f$var$queryParamPrefixes = [
    "InstantGlobals",
    "icbm"
];
function $8031b44000f2c28f$var$hasInstantConfigPrefix(key) {
    return $8031b44000f2c28f$var$queryParamPrefixes.some((prefix)=>{
        return key.startsWith(`${prefix}.`) || key.startsWith(`${prefix}__`);
    });
}
class $8031b44000f2c28f$export$14a2f5ed2c1a484d {
    override(queryString, config) {
        return [
            ...queryString.keys()
        ].filter((paramKey)=>$8031b44000f2c28f$var$hasInstantConfigPrefix(paramKey)).map((paramKey)=>{
            const [, key] = paramKey.split(".").map((part)=>part.split("__")).flat();
            return {
                paramKey: paramKey,
                key: key
            };
        }).map(({ paramKey: paramKey , key: key  })=>({
                key: key,
                value: this.parseValue(queryString.get(paramKey))
            })).map(({ key: key , value: value  })=>({
                key: key,
                value: key.startsWith("wg") ? value : this.wrapValueInXXRegions(value)
            })).reduce((newConfig, { key: key , value: value  })=>({
                ...newConfig,
                [key]: value
            }), config);
    }
    parseValue(value) {
        if (value === "true" || value === "false") return value === "true";
        const intValue = parseInt(value, 10);
        if (value === `${intValue}`) return intValue;
        try {
            return JSON.parse(value);
        } catch (ignore) {
            return value || null;
        }
    }
    wrapValueInXXRegions(value) {
        return [
            {
                value: value,
                regions: [
                    "XX"
                ]
            }
        ];
    }
}



$parcel$exportWildcard($583683d1b436d65c$exports, $d4581a365416e9ee$exports);
$parcel$exportWildcard($583683d1b436d65c$exports, $15d63f1bfc4bb821$exports);
$parcel$exportWildcard($583683d1b436d65c$exports, $85c45f0adbe836ae$exports);
$parcel$exportWildcard($583683d1b436d65c$exports, $8031b44000f2c28f$exports);
$parcel$exportWildcard($583683d1b436d65c$exports, $89ffc9b2062f304b$exports);



$parcel$exportWildcard(module.exports, $583683d1b436d65c$exports);
$parcel$exportWildcard(module.exports, $b9c8418edb6cb5ed$exports);


//# sourceMappingURL=index.js.map
